export default __webpack_public_path__ + "static/media/img-0811-czech-republic-full-face.7d5da82e.png";